const data = {
	"body": "<path fill=\"currentColor\" d=\"m20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8a7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42ZM5 11a6 6 0 1 1 6 6a6 6 0 0 1-6-6Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
